<template>
  <div
    :style="{
      '--page-header-height': `${pageHeaderHeight}px`,
      '--scroll-ratio': scrollRatio,
      '--status-bar-height': $dmbcEnv.statusBarHeight,
      '--initial-font-color': theme.fill ? theme.topIconColor : undefined,
      '--buy-bottom': $transformPx(theme.buyBottom || 0),
      '--buy-left': (theme.buyLeft ? theme.buyLeft : '50') + '%',
      '--buy-width': theme.buyWidth ? $transformPx(theme.buyWidth) : '100%',
    }"
    :class="[
      _[`scrollRatio${scrollRatio}`],
      ($dmbcEnv.wechat || $dmbcEnv.yancheng || $dmbcEnv.inGuangDa) && _.wechat,
      !theme.fill && _.classical,
    ]"
  >
    <div ref="header" :class="_.header">
      <dmbc-base-icon
        v-track="{
          name: '返回',
          id: `${componentId}-back`,
        }"
        name="back"
        :class="_.icon"
        @click="handleBackClick"
      />
      <div v-if="pageTheme && pageTheme.title" :class="_.title">
        {{ pageTheme.title }}
      </div>
      <div :class="_.grow"></div>
      <template v-if="!shareDataLoading">
        <dmbc-base-icon
          v-if="theme.hasSearch === true"
          v-track="{
            name: '搜索',
            id: `${componentId}-search`,
          }"
          name="search"
          :class="_.icon"
          @click="handleSearchClick"
        />
        <dmbc-base-icon
          v-if="shareData.title"
          v-track="{
            name: '分享',
            id: `${componentId}-share`,
          }"
          name="share"
          :class="_.icon"
          @click="handleShareClick"
        />
      </template>
    </div>

    <div :class="_.banner">
      <video
        v-if="theme.topBackground.endsWith('.mp4')"
        :src="theme.topBackground"
        muted
        autoplay
        loop
        playsinline
        webkit-playsinline
        :class="_.image"
      />

      <DmbcBaseLottie
        v-else-if="theme.topBackground.endsWith('.json')"
        :src="theme.topBackground"
        :class="_.image"
      />

      <img v-else :src="theme.topBackground" :class="_.image" />

      <img
        v-if="theme.hasBuy"
        v-track="{
          name: '85券-立即购买',
          newId: 'li_ji_gou_mai-yi_quan_tong',
          extra: {
            quan_id: theme.commodityId,
            quan_jin_e: goodsData.price,
            quan_ming_cheng: goodsData.commodityTitle,
            track_code: '4f17b8f40d9b488baeaed065d9192ad8',
          },
        }"
        :src="theme.buyBackground"
        :class="[_.buy, !theme.buyLeft && _.tramsform]"
        @click="goBuy"
      />

      <div v-if="theme.hasSales && theme.commodityId" :class="_.counts">
        <span :class="_.stock">剩余：{{ goodsData.surplusStock || 0 }}</span>
        <span :class="_.sales">销量：{{ goodsData.sales || 0 }}</span>
      </div>
      <div v-if="theme.hasRule && theme.ruleUrl" :class="_.rule" @click="goUrl">
        活动指南
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { bindEvent, clamp, ii } from 'vtils'
  // import { submit } from '@/utils'
  import { onPageVisibilityChange } from '@/utils'
  import { Toast } from 'vant'

  async function getShareInfo(shareUrl, useUniSharePage) {
    const shareId = shareUrl.match(/appLinkId=(\w+)/)?.[1] || ''
    if (!shareId) {
      return {}
    }
    try {
      const isTest = shareUrl.includes('h5-test')
      const res = await fetch(
        `https://h5p-gw.${
          isTest ? 'duotest' : 'gogpay'
        }.cn/basicPageConfig/api/getAppLinkDetail`,
        {
          method: 'POST',
          body: JSON.stringify({
            appLinkId: shareId,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
        .then(res => res.json())
        .then(res => res.data)
      return {
        title: res.shareTitle,
        desc: res.shareContent,
        cover: res.shareImgUrl,
        url: useUniSharePage
          ? `https://h5.gogpay.cn/${
              isTest ? 'h5-test' : 'h5'
            }/dcb-third-open/index.html#/home?appLinkId=${shareId}`
          : location.href,
      }
    } catch (err) {
      console.log(err)
      return {}
    }
  }

  export default Vue.extend({
    inject: {
      pageTheme: 'pageTheme',
    },

    props: {
      pageElement: {
        type: null,
        default: () => window,
      },
    },

    data: () => {
      return {
        pageHeaderHeight: 0,
        scrollRatio: 0,
        shareDataLoading: true,
        shareData: {},
        goodsData: {},
      }
    },

    watch: {
      shareData() {
        if (window.wechat && this.shareData.title) {
          window.wechat.updateShareData({
            title: this.shareData.title,
            imgUrl: this.shareData.cover,
            desc: this.shareData.desc,
            link: this.shareData.url,
          })
        }
      },
    },

    mounted() {
      // this.$eventBus.on('triggerBuy', () => {
      //   if (this.theme.hasBuy && this.theme.commodityId) {
      //     this.goBuy()
      //   }
      // })
      ii(async () => {
        if (this.theme.hasShare === true && this.theme.qrCodeData) {
          this.shareData = await getShareInfo(
            this.theme.qrCodeData,
            this.theme.shareMode === 'poster',
          )
        }
        this.shareDataLoading = false
      })

      this.$nextTick(() => {
        if (this.theme.commodityId) {
          this.getCommodityData()
        }
        const pageElementNode =
          typeof this.pageElement === 'string'
            ? document.querySelector(this.pageElement)
            : this.pageElement
        const pageHeaderHeight =
          this.$refs.header.getBoundingClientRect().height
        this.pageHeaderHeight = pageHeaderHeight

        this.$eventBus.emit('setPageHeaderHeight', { pageHeaderHeight })
        this.$once(
          'hook:beforeDestroy',
          bindEvent(pageElementNode)('scroll', () => {
            const ratio = clamp(
              pageElementNode.scrollY / pageHeaderHeight,
              0,
              1,
            )
            this.scrollRatio = ratio
          }),
        )
      })
    },

    methods: {
      handleBackClick() {
        this.$dmbcBack()
      },

      handleSearchClick() {
        this.$router.push(`/diy/search/index?pageId=${this.pageId}`)
      },

      handleShareClick() {
        window.dcb.share(this.shareData)
      },
      async getCommodityData() {
        this.goodsData = await this.$dmbcApi.getCommodityData({
          commodityId: this.theme.commodityId,
        })
      },
      async goBuy() {
        // $.start('正在下单...')
        Toast.loading({
          duration: 1500, // 持续展示 toast
          forbidClick: true,
          message: '正在下单...',
        })
        const preOrderRequestData = {
          preOrderType: 2,
          skuInfo: [
            {
              commodityId: this.goodsData.commodityId,
              count: 1,
              skuId: this.goodsData.skuList[0].skuId,
              sellChannelId: this.goodsData.refUserGroupId,
            },
          ],
        }

        const off = onPageVisibilityChange(async visible => {
          if (visible) {
            off()
            location.reload()
          }
        })

        const data = await this.$dmbcApi.generalTradePreOrder(
          preOrderRequestData,
        )
        // 弹窗进行了路由改造，直接 redirect 过去即可
        this.$router.push({
          name: 'OrderPlace',
          query: {
            type: 'normal',
            data: JSON.stringify(data),
            preOrderRequestData: JSON.stringify(preOrderRequestData),
          },
        })
      },
      goUrl() {
        window.dcb.navigateTo({
          url: this.theme.ruleUrl,
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    height: 44px;
    box-sizing: content-box;
    padding: 0 10px;
    padding-top: var(--status-bar-height);
    z-index: 100;
    background-color: rgba(white, var(--scroll-ratio));

    .icon {
      font-size: 20px;
      color: rgba(black, var(--scroll-ratio));

      + .icon {
        margin-left: 24px;
      }
    }

    .title {
      position: absolute;
      left: 50%;
      top: 50%;
      padding-top: var(--status-bar-height);
      transform: translate3d(-50%, -50%, 0);
      font-size: 18px;
      font-weight: bold;
      color: rgba(black, var(--scroll-ratio));
      max-width: 70%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .grow {
      flex-grow: 1;
    }
  }

  .banner {
    position: relative;
    width: 100%;
    overflow: hidden;
    font-size: 0;

    .image {
      display: block;
      width: 100%;
      object-fit: cover;
    }
    .buy {
      width: var(--buy-width);
      position: absolute;
      bottom: var(--buy-bottom);
      left: var(--buy-left);
    }
    .tramsform {
      transform: translateX(-50%);
    }
    .counts {
      position: absolute;
      bottom: 17px;
      display: flex;
      flex-direction: column;
      span {
        text-align: center;
        width: 80px;
        height: 20px;
        background: rgba(231, 62, 100, 0.75);
        border-radius: 0px 100px 100px 0px;
        border: 1px solid #ffffff;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
        text-shadow: 1px 1px 1px rgba(150, 0, 0, 0.5);
        font-style: normal;
      }

      .sales {
        margin-top: 6px;
      }
    }
    .rule {
      position: absolute;
      bottom: 6px;
      right: 0;
      width: 78px;
      height: 30px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 100px 0px 0px 100px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 28px;
      text-align: center;
      font-style: normal;
    }
  }

  .wechat {
    .header {
      display: none;
    }

    .banner {
      .mask {
        display: none;
      }
    }
  }

  .scrollRatio0 {
    .header {
      .icon {
        color: var(--initial-font-color, white);
      }

      .title {
        color: transparent;
      }
    }
  }

  .classical {
    .header {
      background-color: white;

      .icon {
        color: black;
      }

      .title {
        color: black;
      }
    }

    .banner {
      margin-top: var(--page-header-height);
    }
  }
</style>
